import NotFound from '../components/NotFound';

export default function Work() {
  return <NotFound pageName="Our Work" />;
}
